import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var ReturnedToSenderIA = function ReturnedToSenderIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "9LbFDA",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous avez tenté d'expédier une commande et qu'elle vous a été retournée, cela peut être dû à plusieurs raisons. Dans notre "
    }, {
      "children": [{
        "type": 0,
        "value": "guide détaillé"
      }],
      "type": 8,
      "value": "ArticleLinkFormatting"
    }, {
      "type": 0,
      "value": " sur les problèmes de "
    }, {
      "children": [{
        "type": 0,
        "value": "retour à l'expéditeur"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ", vous trouverez la marche à suivre pour les expéditions nationales ou internationales."
    }],
    values: {
      ArticleLinkFormatting: ArticleLinkFormatting,
      BoldFormatting: BoldFormatting
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "1gsUye",
    defaultMessage: [{
      "type": 0,
      "value": "Contactez-nous si vous avez besoin d'une assistance. Nous sommes là pour vous aider."
    }]
  })));
};
var ArticleLinkFormatting = function ArticleLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("26594585812891"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var BoldFormatting = function BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};